import { create } from 'zustand';

import type { Client, ClientState } from '@/features/client/types/client';

const useClientStore = create<ClientState>()((set) => ({
  client: {
    locale: 'nl-NL',
    currency: 'EUR',
    language: 'nl',
    country: 'NL',
  },
  setClient: (client: Client): void => {
    set(() => {
      return {
        client: client,
      };
    });
  },
}));

export default useClientStore;
